import { OCISID, SITEURL } from "@libTs/cms.globals";
import { updateURLParameters } from "../helpers/url.helper";
import { IBrand, IItemData } from "../interfaces/products.interfaces";
import { IItem } from "../interfaces/cart.interfaces";
import axios from "axios";

export class ProductsService {
    public isLoadingProducts = false;
    public isLoadingMoreProducts = false;

    public isInited = false;

    public brand?: IBrand;
    public brands: Array<IBrand> =
        typeof CB_BRANDS === "object" && Array.isArray(CB_BRANDS)
            ? (CB_BRANDS as Array<IBrand>)
            : [];

    public itemData: IItemData = {
        Items: [],
        ResponseMessage: "OK",
        ResponseStatus: 100,
    };

    public fulltext = "";
    public searchFulltext = "";
    public brandid = "";

    public hasMoreResults = false;
    public drpBrand = false;
    public dropdownLoading = false;

    private skipStartWith = 0;
    public skip = 0;

    private OpenBabelModule = window["OpenBabelModule"];
    private OpenBabel;

    public openTab = {
        id: "",
        tab: "",
    };

    public infoId = "";

    private searchQueue: Array<any> = [];

    // private $q: IQService, // used for Promises, see https://docs.angularjs.org/api/ng/service/$q#-q-constructor
    // private httpPromise: HttpPromiseService,
    // private $window: IWindowService
    constructor() {
        this.OpenBabel = this.OpenBabelModule();
    }

    public terminatePendingSearchRequests(): void {
        // console.log(this.searchQueue);

        if (this.searchQueue.length > 0) {
            // console.log("terminatePendingSearchRequests");
            for (let i = this.searchQueue.length - 1; 0 <= i; --i) {
                this.searchQueue[i]?.abort();
            }
            this.searchQueue = [];
        }
    }

    public removeRequest(request: any): void {
        if (this.searchQueue.length > 0) {
            // console.log("removeRequest");
            const i = this.searchQueue.findIndex((r) => r === request);
            if (0 <= i) {
                this.searchQueue[i]?.abort();
                this.searchQueue.splice(i, 1);
            }
            // console.log(this.searchQueue);
        }
    }

    public selectBrand(
        brandindex: number,
        loadItems?: boolean,
        useOciSession?: boolean,
    ): void {
        this.drpBrand = false;
        this.brand = this.brands[brandindex];

        if (loadItems !== false) {
            this.dropdownLoading = true;
            this.loadItems(
                this.searchFulltext,
                this.brand.Code,
                51,
                false,
                false,
                useOciSession,
            );
        }
    }

    public sendProductSearch(e: Event): void {
        e.preventDefault();

        let searchQuery = "";

        if (this.fulltext.length > 0) {
            searchQuery += "term=" + this.fulltext;
        }
        if (this.brandid.length > 0) {
            searchQuery +=
                (searchQuery.length > 0 ? "&" : "") + "brand=" + this.brandid;
        }
        if (searchQuery.length > 0) {
            window.location.href = "shop?" + searchQuery;
        }
    }

    public loadItems(
        fulltext: string,
        brandid: string,
        take: number,
        startWithSearch: boolean,
        skipUrlStateReplacement: boolean,
        useOciSession?: boolean,
    ): void {
        // console.log("loadItems");
        // console.log( 'term=' + fulltext, 'brand=' + this.brandid );
        // console.log( 'svc.fulltext=' + this.fulltext, 'svc.searchFulltext=' + this.searchFulltext );

        // Skip startwithsearch if brandId is set
        if (typeof brandid === "string" && brandid.length > 0) {
            startWithSearch = false;
        }

        if (!skipUrlStateReplacement) {
            updateURLParameters(window.location.href, [
                { param: "term", value: fulltext },
                { param: "brand", value: brandid },
            ]);
        }

        this.skipStartWith = 0;
        if (fulltext.length === 0 && brandid.length === 0) {
            // console.warn( 'loadItems failed: Either "term" or "brand" must be set.' );

            this.itemData = {
                Items: [],
                ResponseMessage: "OK",
                ResponseStatus: 200,
            };

            this.hasMoreResults = false;
            this.dropdownLoading = false;

            return;
        }

        const itemsRequest = {
            fulltext: fulltext,
            brandid: brandid,
            skip: 0,
            take: take,
            startWithSearch: startWithSearch,
            useOciSession: useOciSession === true,
        };

        this.itemData = {
            Items: [],
            ResponseMessage: "OK",
            ResponseStatus: 100,
        };
        this.isLoadingProducts = true;

        // Terminate pending requests
        this.terminatePendingSearchRequests();

        const controller = new AbortController();

        const request = axios.post(
            SITEURL +
                "actions/sapShop/products/get-products" +
                (OCISID ? `?sid=${OCISID}` : ""),
            itemsRequest,
            {
                signal: controller.signal,
                responseType: "json",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            },
        );

        // Add request to queue
        this.searchQueue.push(controller);

        request
            .catch(
                // error
                (err) => {
                    if (!startWithSearch) {
                        this.itemData.ResponseStatus = 500;
                        this.dropdownLoading = false;

                        console.warn("Error: No response from server.");
                        console.log(err);
                    }
                },
            )
            .then(
                // success
                (response) => {
                    // console.log(response);
                    if (response && response.data) {
                        const data = response.data;

                        // check if in maintenance mode
                        if (data.ResponseStatus === 555) {
                            window.location.href = SITEURL;
                            return;
                        }

                        // console.log(data);

                        this.hasMoreResults = data.Items.length >= take;

                        const itemsToShow =
                            data.Items.length - (this.hasMoreResults ? 1 : 0);
                        this.skip += itemsToShow;
                        for (let i = 0; i < itemsToShow; ++i) {
                            // push all except last
                            this.itemData.Items.push(data.Items[i]);
                        }

                        this.itemData.ResponseStatus = data.ResponseStatus;
                        // return this.$q.resolve();
                    } else {
                        console.warn(
                            "Error while fetching items: No data received.",
                        );
                        // console.log(response);

                        if (startWithSearch) {
                            // resolve, because it may not find an item in startwith, but in fulltext
                            // return this.$q.resolve();
                        } else {
                            this.itemData.ResponseStatus = 400;
                            // return this.$q.reject();
                        }
                    }
                },
            )
            .then(() => {
                if (startWithSearch) {
                    this.skipStartWith = this.itemData.Items.length;
                }
                this.dropdownLoading = false;

                if (startWithSearch && this.itemData.Items.length < take - 1) {
                    this.fetchMoreItems(
                        fulltext,
                        brandid,
                        this.itemData.Items.length,
                        take - this.itemData.Items.length,
                        true,
                        true,
                        useOciSession,
                    );
                }

                this.itemData.Items.forEach((item) => {
                    const dataRequest = axios.post(
                        SITEURL +
                            "actions/sapShop/products/product-info?itemCode=" +
                            encodeURIComponent(item.ItemCode),
                        itemsRequest,
                        {
                            responseType: "json",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest",
                            },
                        },
                    );

                    dataRequest.then((res: any) => {
                        item.overlayData = res.data;
                    });
                });
            })
            .finally(() => {
                this.isLoadingProducts = false;
                this.dropdownLoading = false;
                this.removeRequest(controller);
            });
    }

    public fetchMoreItems(
        fulltext: string,
        brandid: string,
        skip: number,
        take: number,
        hideLoading: boolean,
        removeNewDuplicates: boolean,
        useOciSession?: boolean,
    ): Promise<void> {
        // console.log("fetchMoreItems");
        if (fulltext.length <= 0 && brandid.length <= 0) {
            throw new Error(
                "FetchMoreItems failed: Either fulltext or brandid must be set.",
            );
        }

        const itemsRequest = {
            fulltext: fulltext,
            brandid: brandid,
            skip: skip - this.skipStartWith,
            take: take,
            startWithSearch: false,
            useOciSession: useOciSession === true,
        };

        this.itemData.ResponseStatus = 100;
        this.isLoadingMoreProducts = true;

        let controller = new AbortController();

        const request = axios.post(
            SITEURL +
                "actions/sapShop/products/get-products" +
                (OCISID ? `?sid=${OCISID}` : ""),
            itemsRequest,
            {
                signal: controller.signal,
                responseType: "json",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            },
        );

        // Add request to queue
        this.searchQueue.push(controller);

        return request
            .catch(
                // error
                (err) => {
                    this.itemData.ResponseStatus = 500;
                    // this.$q.reject();
                    console.error(err);
                },
            )
            .then(
                // success
                (response) => {
                    let hasRemovedDuplicates = false;

                    if (response && response.data) {
                        const data = response.data;

                        // check if in maintenance mode
                        if (data.ResponseStatus === 555) {
                            window.location.href = SITEURL;
                            // return this.$q.reject();
                        }

                        const originalResponseItemsLength = data.Items.length;
                        if (removeNewDuplicates) {
                            const toDeleteItemIndexes = [];
                            for (let i = 0; i < data.Items.length; ++i) {
                                const item = data.Items[i];
                                const existingItemIndex =
                                    this.itemData.Items.findIndex(
                                        (existingItem) =>
                                            existingItem.ItemCode ===
                                            item.ItemCode,
                                    );
                                if (existingItemIndex >= 0) {
                                    toDeleteItemIndexes.push(i);
                                }
                            }
                            if (toDeleteItemIndexes.length > 0) {
                                // console.log(
                                //     "removing " +
                                //         toDeleteItemIndexes.length.toString() +
                                //         " duplicates",
                                // );
                                // console.log( 'before deleting:', data.Items );
                                hasRemovedDuplicates = true;
                                for (
                                    let i = toDeleteItemIndexes.length - 1;
                                    i >= 0;
                                    --i
                                ) {
                                    // console.log( 'deleting ' + data.Items[ toDeleteItemIndexes[ i ] ].ItemCode );
                                    data.Items.splice(
                                        toDeleteItemIndexes[i],
                                        1,
                                    );
                                }
                                // console.log( 'after deleting:', data.Items );
                            }
                        }

                        this.hasMoreResults =
                            originalResponseItemsLength >= take;

                        const itemsToShow =
                            originalResponseItemsLength -
                            (this.hasMoreResults ? 1 : 0);
                        this.skip += itemsToShow;
                        data.Items = data.Items.slice(0, take - 1);
                        this.itemData.Items = this.itemData.Items.concat(
                            data.Items,
                        );

                        this.itemData.ResponseStatus = data.ResponseStatus;
                        // return this.$q.resolve(hasRemovedDuplicates);
                    } else {
                        this.itemData.ResponseStatus = 400;

                        console.warn(
                            "Error while fetching items: No data received.",
                        );
                        // return this.$q.reject(false);
                    }

                    if (hasRemovedDuplicates) {
                        // console.log(
                        //     "duplicates removed, loading more...",
                        //     /*this.itemData.Items.length, this.hasMoreResults, this.skip, take + skip*/
                        // );
                        this.fetchMoreItems(
                            fulltext,
                            brandid,
                            this.hasMoreResults ? this.skip - 1 : this.skip,
                            take + skip - this.itemData.Items.length,
                            hideLoading,
                            false,
                            useOciSession,
                        );
                    }
                    if (!hideLoading && !hasRemovedDuplicates) {
                        this.isLoadingMoreProducts = false;
                        this.dropdownLoading = false;
                    }
                },
            )
            .finally(() => {
                this.dropdownLoading = false;
                this.isLoadingMoreProducts = false;

                // console.log("check this");

                this.removeRequest(request);
            });
    }

    public getQueryResultsCountStr(single: string, multi: string): string {
        const count = this.itemData.Items.length;
        return (
            (this.hasMoreResults ? "> " : "") +
            count +
            " " +
            (count === 1 ? single : multi)
        );
    }

    public getResultsListedCountStr(single: string, multi: string): string {
        const count = this.itemData.Items.length;
        return count + " " + (count === 1 ? single : multi);
    }

    public showMonolotOption(item: IItem): boolean {
        return item && "Brand" in item && item.BrandName === "ScienCell";
    }

    public setTab(itemCode: string, tab: string): void {
        if (this.openTab.id == itemCode && this.openTab.tab == tab) {
            this.openTab.id = "";
            this.openTab.tab = "";
        } else {
            this.openTab.id = itemCode;
            this.openTab.tab = tab;
        }
    }

    public downloadSDF(smiles: string, itemCode: string) {
        const mol = new this.OpenBabel.OBMol();
        const conv = new this.OpenBabel.ObConversionWrapper();

        try {
            conv.setInFormat("", "smi");
            conv.readString(mol, smiles);
            const gen3d = this.OpenBabel.OBOp.FindType("Gen3D"); // FindType is actually a factory constructor, no need to use "new" here
            if (!gen3d.Do(mol, "")) console.error("Generate 3D failed");
            else {
                conv.setOutFormat("", "sdf");
                const outputData = conv.writeString(mol, false);

                const n = outputData.lastIndexOf("\n$$$$");
                const str2 =
                    outputData.substring(0, n) +
                    "\n\n> <structure_id>\n" +
                    itemCode +
                    "\n" +
                    outputData.substring(n);

                const element = document.createElement("a");
                element.setAttribute(
                    "href",
                    "data:text/plain;charset=utf-8," + encodeURIComponent(str2),
                );
                element.setAttribute("download", itemCode + ".sdf");

                element.style.display = "none";
                document.body.appendChild(element);

                element.click();

                document.body.removeChild(element);
            }
        } finally {
            conv.delete(); // free ObConversionWrapper instance
            mol.delete();
        }
    }

    public downloadAllSDF(items: Array<any>) {
        items.forEach((item) => {
            if (item.CASData.smiles && item.ItemCode) {
                this.downloadSDF(item.CASData.smiles, item.ItemCode);
            }
        });
    }

    public getCASProducts(CAS: string): any {
        // console.log("getCASProducts", CAS);

        const itemsRequest = {
            fulltext: CAS,
        };

        let controller = new AbortController();

        const request = axios.post(
            SITEURL +
                "actions/sapShop/products/get-products" +
                (OCISID ? `?sid=${OCISID}` : ""),
            itemsRequest,
            {
                signal: controller.signal,
                responseType: "json",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            },
        );

        return request
            .catch(
                // error
                (err) => {
                    console.warn("Error: No response from server.");
                    console.log(err);
                },
            )
            .then(
                // success
                (response) => {
                    // console.log(response);
                    if (response && response.data) {
                        const data = response.data;

                        // check if in maintenance mode
                        if (data.ResponseStatus === 555) {
                            window.location.href = SITEURL;
                            return;
                        }

                        this.itemData.ResponseStatus = data.ResponseStatus;
                        return data.Items;
                    } else {
                        console.warn(
                            "Error while fetching items: No data received.",
                        );
                        // console.log(response);

                        this.itemData.ResponseStatus = 400;
                        // return this.$q.reject();
                    }
                },
            )
            .finally(() => {
                this.removeRequest(controller);
            });
    }

    public init(fulltext: string, brand: IBrand, skip: number, take: number) {
        if (this.isInited == false) {
            this.searchFulltext = fulltext;
            this.brand = brand;
            this.skip = skip;
            this.loadItems(fulltext, brand.Code, take, true, true);

            this.isInited = true;
        }

        return "";
    }

    public getMultipleItemPrices(itemCodes: Array<string>): Promise<any> {
        if (itemCodes.length === 0) {
            return Promise.resolve({});
        }

        const request = axios.post(
            SITEURL + "actions/sapShop/products/get-multiple-item-prices",
            {
                itemCodes: itemCodes,
            },
            {
                responseType: "json",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            },
        );

        return request
            .catch(
                // error
                (err) => {
                    console.warn("Error: No response from server.");
                    console.log(err);
                    return {};
                },
            )
            .then(
                // success
                (response) => {
                    if (response && response.data) {
                        console.log(response.data);

                        return response.data;
                    } else {
                        console.warn(
                            "Error while fetching item prices: No data received.",
                        );
                        console.log(response);
                        return {};
                    }
                },
            );
    }

    public getMultipleItemInfos(itemCodes: Array<string>): Promise<any> {
        if (itemCodes.length === 0) {
            return Promise.resolve({});
        }

        const request = axios.post(
            SITEURL + "actions/sapShop/products/get-multiple-item-infos",
            {
                itemCodes: itemCodes,
            },
            {
                responseType: "json",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            },
        );

        return request
            .catch(
                // error
                (err) => {
                    console.warn("Error: No response from server.");
                    console.log(err);
                    return {};
                },
            )
            .then(
                // success
                (response) => {
                    if (response && response.data) {
                        // console.log(response.data);

                        return response.data;
                    } else {
                        console.warn(
                            "Error while fetching item prices: No data received.",
                        );
                        console.log(response);
                        return {};
                    }
                },
            );
    }
}
